/* Noah's Marine - Spectrum "Find your gelcoat" finder. Data comes live from
   /collections/spectrum-gelcoats?view=gelcoat-data (templates/collection.gelcoat-data.liquid). */
(function () {
  'use strict';
  if (window.__gcfLoaded) return; window.__gcfLoaded = true;

  // Boat brands as Spectrum lists them (display spelling). Matching ignores case, spaces and punctuation,
  // so "Fourwinns" = "Four Winns". A brand not listed here still works: its first word is used as the brand.
  var BRANDS = ['ARC','Action Craft/Southwind','Albemarle','American Reinforced Plastics','Aviara','Baja','Bay Boats','Bayliner',
    'Beneteau','Bertram','Blackfin','Bluewater','Boston Whaler','Bryant','C-Dory','C-Hawk','Campion','Carolina Classic',
    'Carolina Skiff','Carver','Century','Chaparral','Chris-Craft','Cobalt','Cobia','Correct Craft','Crest','Crownline',
    'Cruisers Yachts','Fiberfab','Four Winns','Glastron','Grady-White','Hewes Bonefisher','HeyDay','HK Research','Hurricane',
    'Hydra-Sports','Ikon','Intrepid','Invincible','Jones Brothers','Jupiter','Kawasaki','Key West','Lasco','Lund','Mako',
    'Malibu','Malibu/Axis','MasterCraft','Maverick','Maxum','MBG','McLaughlin','Monterey','NauticStar','Nautique',
    'Nautique/Correct Craft','Navan','Nitro','Osprey','Parker','Pathfinder','Pioneer','ProCraft','Pursuit','Ranger','Regal',
    'Rinker','Robalo','Sailfish','Scarab','Scout','Sea Born','Sea Fox','Sea Hunt','Sea Pro','Sea Ray','Sea-Doo','Sea-Port',
    'Silverton','Skagit','Skeeter','Sportsman','Spyder','Stingray','Sundance','Supra','Supra/Moomba','Tahoe','Tidewater',
    'Tige','Triton','Trophy','US Marine','Wellcraft','Yamaha','Yellowfin'];
  var ALIAS = { parkerboats: 'Parker', jaycorv: 'Jayco RV', sporstman: 'Sportsman', stringray: 'Stingray', trition: 'Triton' };
  var CACHE_KEY = 'gcf-data-v2', CACHE_MS = 30 * 60 * 1000;

  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
  var BMAP = {}; BRANDS.forEach(function (b) { BMAP[norm(b)] = b; });
  Object.keys(ALIAS).forEach(function (k) { BMAP[k] = ALIAS[k]; });

  var YR_TAIL = /\s+((?:19|20)\d\d(?:\s*-\s*(?:19|20)\d\d)?(?:\s*(?:,|&)\s*(?:19|20)\d\d(?:\s*-\s*(?:19|20)\d\d)?)*(?:\s+and\s+newer)?)$/i;
  var SIZE_LEAD = /^(?:(?:\d+\s*oz\.?|paste|repair|match|kit|quarts?|gallons?|and|&|\/|,)\s*)+[\u2013\u2014-]\s+/i;
  var NEWER_TAIL = /\s+((?:19|20)\d\d)\s+and\s+newer$/i;

  function splitBrand(body) {
    var w = body.split(/\s+/);
    for (var i = Math.min(w.length - 1, 5); i >= 1; i--) {
      var k = norm(w.slice(0, i).join(' '));
      if (BMAP[k]) return { b: BMAP[k], c: w.slice(i).join(' '), known: true };
    }
    if (BMAP[norm(body)]) return { b: BMAP[norm(body)], c: '', known: true };
    return { b: w[0], c: w.slice(1).join(' '), known: false };
  }

  // Returns {brand, colour, years (text), ranges: [[from,to],...] or null for "all years", known}
  function parseTitle(t) {
    t = String(t).replace(/\s+/g, ' ').trim();
    var brand, colour, yrs = '';
    if (t.indexOf(' / ') > -1) { // older "Kit / Brand / Years / Colour" titles
      var p = t.split(' / ').map(function (x) { return x.replace(/\/\s*$/, '').trim(); });
      var sb = splitBrand(p[1] || '');
      brand = sb.b + (sb.c ? ' ' + sb.c : ''); brand = BMAP[norm(brand)] || brand;
      yrs = p[2] || ''; colour = p[3] || '';
      var known = !!BMAP[norm(p[1] || '')];
    } else {
      var m = t.match(/^.*?\s[\u2013\u2014-]\s(.*)$/);
      var rest = m ? m[1] : t;
      rest = rest.replace(SIZE_LEAD, ''); // e.g. "Spectrum Gelcoat - Quart - Sea Ray ..."
      var y = rest.match(NEWER_TAIL) || rest.match(YR_TAIL);
      if (y) { yrs = y[0].trim(); rest = rest.slice(0, y.index); }
      var s = splitBrand(rest.trim()); brand = s.b; colour = s.c; known = s.known;
    }
    return { brand: brand, colour: colour.trim(), years: yrs.trim(), ranges: parseYears(yrs), known: known };
  }

  function parseYears(s) {
    s = String(s || '').trim();
    if (!s || /^all$/i.test(s)) return null;
    var max = new Date().getFullYear() + 1, out = [];
    var nw = s.match(/^((?:19|20)\d\d)\s+and\s+newer$/i);
    if (nw) return [[+nw[1], Math.max(max, +nw[1])]];
    s.split(/\s*(?:,|&)\s*/).forEach(function (seg) {
      var r = seg.match(/^((?:19|20)\d\d)(?:\s*-\s*((?:19|20)\d\d))?$/);
      if (r) out.push([+r[1], r[2] ? +r[2] : +r[1]]);
    });
    return out.length ? out : null;
  }

  function covers(k, year) {
    if (!k.ranges) return true;
    for (var i = 0; i < k.ranges.length; i++) if (year >= k.ranges[i][0] && year <= k.ranges[i][1]) return true;
    return false;
  }

  function money(c) { return '$' + (c / 100).toFixed(2); }
  // Single-variant products have no size name; work it out from the product title.
  function sizeName(t, ptitle) {
    if (t && t !== 'Default Title') return t;
    var p = String(ptitle || '');
    if (!/2\s*oz|paste/i.test(p)) {
      if (/\bquarts?\b/i.test(p)) return 'Quart';
      if (/\bgallons?\b/i.test(p)) return 'Gallon';
    }
    return '2 oz Paste Kit';
  }
  function isKit(name) { return /2\s*oz|paste|\bkit\b/i.test(name); }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  var dataPromise = null;
  function loadData(pages) {
    if (dataPromise) return dataPromise;
    try {
      var c = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      if (c && Date.now() - c.t < CACHE_MS && c.k && c.k.length) { dataPromise = Promise.resolve(build(c.k)); return dataPromise; }
    } catch (e) {}
    var base = root() + 'collections/spectrum-gelcoats?view=gelcoat-data&sort_by=title-ascending&page=';
    function get(n) { return fetch(base + n, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }); }
    var n = Math.max(1, pages || 1), reqs = [];
    for (var i = 1; i <= n; i++) reqs.push(get(i));
    dataPromise = Promise.all(reqs).then(function (res) {
      var more = [];
      var total = res[0].pages || 1;
      for (var j = n + 1; j <= total; j++) more.push(get(j)); // in case the collection grew past the page estimate
      return Promise.all(more).then(function (r2) {
        var kits = [];
        res.concat(r2).forEach(function (d) { kits = kits.concat(d.kits || []); });
        try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), k: kits })); } catch (e) {}
        return build(kits);
      });
    });
    dataPromise.catch(function () { dataPromise = null; });
    return dataPromise;
  }

  function build(rows) {
    var brands = {}, seen = {};
    rows.forEach(function (r) {
      if (seen[r[1]]) return; seen[r[1]] = 1;
      var p = parseTitle(r[0]);
      var key = norm(p.brand);
      var B = brands[key] || (brands[key] = { name: p.brand, kits: [] });
      var vs = (r[2] || []).map(function (v) { return [v[0], sizeName(v[1], r[0]), v[2], v[3]]; });
      B.kits.push({ title: r[0], handle: r[1], colour: p.colour || 'Colour not listed', years: /^all$/i.test(p.years) ? '' : p.years, ranges: p.ranges, variants: vs,
        noKit: vs.length > 0 && !vs.some(function (v) { return isKit(v[1]); }),
        qgOnly: (function () { var q = vs.some(function (v) { return v[1] === 'Quart'; }), g = vs.some(function (v) { return v[1] === 'Gallon'; }); return q && g ? 'quart/gallon only' : q ? 'quart only' : g ? 'gallon only' : 'quart/gallon only'; })() });
    });
    var list = Object.keys(brands).map(function (k) {
      var B = brands[k];
      B.kits.sort(function (a, b) { return a.colour.localeCompare(b.colour) || a.years.localeCompare(b.years); });
      var lo = 9999, hi = 0;
      B.kits.forEach(function (kt) { (kt.ranges || []).forEach(function (r) { lo = Math.min(lo, r[0]); hi = Math.max(hi, r[1]); }); });
      B.lo = lo; B.hi = hi;
      return B;
    });
    list.sort(function (a, b) { return a.name.localeCompare(b.name, 'en', { sensitivity: 'base' }); });
    return list;
  }

  function opt(sel, value, label, selected) {
    var o = document.createElement('option'); o.value = value; o.textContent = label; if (selected) o.selected = true; sel.appendChild(o); return o;
  }
  function reset(sel, placeholder) { sel.innerHTML = ''; opt(sel, '', placeholder); }

  function init(el) {
    if (el.__gcf) return; el.__gcf = true;
    var q = function (s) { return el.querySelector(s); };
    var sB = q('[data-gcf-brand]'), sY = q('[data-gcf-year]'), sC = q('[data-gcf-colour]'), sS = q('[data-gcf-size]');
    var wS = q('[data-gcf-size-wrap]'), out = q('[data-gcf-result]'), status = q('[data-gcf-status]');
    var go = q('[data-gcf-go]'), rTitle = q('[data-gcf-result-title]'), rMeta = q('[data-gcf-result-meta]');
    var current = el.getAttribute('data-current-handle') || '';
    var list = [], brand = null, kit = null;

    function setStatus(t) { status.textContent = t || ''; status.hidden = !t; }

    function fillBrands() {
      reset(sB, 'Choose a brand');
      list.forEach(function (B, i) { opt(sB, String(i), B.name + ' (' + B.kits.length + ')'); });
      sB.disabled = false;
    }
    function onBrand() {
      brand = list[+sB.value] || null; kit = null;
      reset(sY, 'Choose a year'); reset(sC, 'Choose a colour');
      sY.disabled = sC.disabled = true; showResult();
      if (!brand) return;
      if (brand.hi) {
        for (var y = brand.hi; y >= brand.lo; y--) opt(sY, String(y), String(y));
      }
      opt(sY, 'all', brand.hi ? 'Not sure / show all years' : 'All years');
      sY.disabled = false;
      if (!brand.hi) { sY.value = 'all'; onYear(); }
    }
    function onYear() {
      kit = null; reset(sC, 'Choose a colour'); sC.disabled = true; showResult();
      if (!brand || !sY.value) return;
      var yr = sY.value === 'all' ? null : +sY.value, n = 0;
      brand.kits.forEach(function (k, i) {
        if (yr === null || covers(k, yr)) { opt(sC, String(i), k.colour + (k.years ? ' (' + k.years + ')' : (brand.hi ? ' (all years)' : '')) + (k.noKit ? ' \u2013 ' + k.qgOnly : '')); n++; }
      });
      if (!n) { reset(sC, 'No colours listed for ' + yr); }
      sC.disabled = !n;
      if (n === 1) { sC.selectedIndex = 1; onColour(); }
    }
    function onColour() {
      kit = brand && sC.value !== '' ? brand.kits[+sC.value] : null;
      if (kit && sS) {
        sS.innerHTML = '';
        var firstAvail = -1;
        kit.variants.forEach(function (v, i) { opt(sS, String(i), v[1] + ' \u2013 ' + money(v[2]) + (v[3] ? '' : ' (sold out)')); if (v[3] && firstAvail < 0) firstAvail = i; });
        if (firstAvail > 0) sS.value = String(firstAvail);
        wS.hidden = kit.variants.length < 2;
      }
      showResult();
    }
    function showResult() {
      if (!kit) { out.hidden = true; if (wS) wS.hidden = true; return; }
      var v = kit.variants[sS ? +sS.value || 0 : 0];
      var url = root() + 'products/' + kit.handle + (v && kit.variants.length > 1 ? '?variant=' + v[0] : '');
      if (!sS && v && kit.noKit) url = root() + 'products/' + kit.handle;
      rTitle.textContent = kit.title;
      rMeta.textContent = (v ? v[1] + ' \u2013 ' + money(v[2]) + (v[3] ? '' : ' (sold out)') : '') + (kit.noKit ? ' \u00b7 No 2 oz paste kit for this colour, ' + (kit.qgOnly === 'quart/gallon only' ? 'quart and gallon only' : kit.qgOnly) : '');
      go.href = url;
      var here = current && current === kit.handle;
      go.textContent = here ? (kit.variants.length > 1 ? 'Switch to this size' : 'This is the kit you\u2019re viewing') : 'View this kit';
      out.hidden = false;
    }
    sB.addEventListener('change', onBrand);
    sY.addEventListener('change', onYear);
    sC.addEventListener('change', onColour);
    if (sS) sS.addEventListener('change', showResult);

    function start() {
      if (el.__gcfStarted) return; el.__gcfStarted = true;
      setStatus('Loading boat brands\u2026');
      loadData(+el.getAttribute('data-pages') || 4).then(function (l) {
        list = l; fillBrands(); setStatus('');
        var pre = el.getAttribute('data-current-title');
        if (pre) {
          var pb = norm(parseTitle(pre).brand);
          for (var i = 0; i < list.length; i++) if (norm(list[i].name) === pb) { sB.value = String(i); onBrand(); break; }
        }
      }).catch(function () { el.__gcfStarted = false; setStatus('Sorry, the colour list didn\u2019t load. Please refresh the page or browse the collection below.'); });
    }
    var det = el.closest('details');
    if (det && !det.open) {
      det.addEventListener('toggle', function () { if (det.open) start(); });
      ['pointerenter', 'focusin', 'touchstart'].forEach(function (t) { det.addEventListener(t, start, { once: true, passive: true }); });
    } else if ('requestIdleCallback' in window) { requestIdleCallback(start, { timeout: 1500 }); } else { setTimeout(start, 200); }
  }

  window.GelcoatFinder = { parseTitle: parseTitle, parseYears: parseYears, sizeName: sizeName, build: build };
  function boot() { document.querySelectorAll('[data-gelcoat-finder]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
